const useQueryParams = (keys: string[]) => {
  const { search } = window.location;
  const queryParams = new URLSearchParams(search);

  const normalizedParams = Array.from(queryParams.entries()).reduce(
    (acc, [key, value]) => {
      acc[key.toLowerCase()] = value;
      return acc;
    },
    {} as Record<string, string>
  );

  return keys.map((key) => normalizedParams[key.toLowerCase()]);
};

export default useQueryParams;
